

























































































































import { CardLimitsModalVueGB } from "@/extensions/cardOperations/CardLimitsModalVueGB";
import SumInput from "@/components/app/SumInput.vue";
import BackLink from "@/components/app/BackLink.vue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox, BackLink, SumInput },
})
export default class CardLimitsModal extends CardLimitsModalVueGB {

  periodEnum: any = {
    1: 'В сутки',
    2: 'В месяц',
    3: 'На одну операцию'
  }

  async mounted() {
    await this.init();
  }
}
